export default "__VITE_ASSET__p$ZpOy92oTssHNriccxfDw__"